import Storage from 'nd-storage'
import { getParameterByName } from 'utils/helpers'
// 框架版本
const APP_CORE = '0.0.1'
// 本地模拟
const SIMULATION = 0
// 开发
const DEVELOPMENT = 1
// 测试
const DEBUG = 2
// 生产
const PRODUCTION = 4
// 预生产
const PREPRODUCTION = 8
// 压测
const PRESSURE = 16
// 集成环境
const INTEGRATION = 32
// 本地开发
const LOCDEVELOPMENT = 64
// 陕西网教通
const SHANXIWJT = 128
// 新加坡
const AWS = 256
// 美国加利福利亚
const AWSCA = 512
// HK
const HK = 1024
const LOC_PROTOCOL = location.protocol + '//'
const LOC_HOST = location.host
// host === hostname:port
const LOC_HOSTNAME = location.hostname

const ENV = (() => {
  switch (LOC_HOSTNAME) {
    case 'localhost':
    case '127.0.0.1':
    case '192.168.244.144':
    case '192.168.244.3':
    case '192.168.244.27':
    case '192.168.253.15':
    case '192.168.254.11':
    case '192.168.218.67':
    case '192.168.0.101':
      return PREPRODUCTION
    default:
      if (/\.dev\.web\.nd$/.test(LOC_HOSTNAME)) {
        return DEVELOPMENT
      }
      // if (/\.debug\.web\.nd$/.test(LOC_HOSTNAME)) {
      if (/\.k8s\.sdp\.nd$/.test(LOC_HOSTNAME)) {
        return DEBUG
      }
      if (/\.pre1\.web\.nd$/.test(LOC_HOSTNAME)) {
        return INTEGRATION
      }
      if (/\.qa\.web\.sdp\.101\.com$/.test(LOC_HOSTNAME)) {
        return PRESSURE
      }
      if (/\.beta\.101\.com$/.test(LOC_HOSTNAME)) {
        return PREPRODUCTION
      }
      if (/\.sneduyun\.com\.cn$/.test(LOC_HOSTNAME)) {
        return SHANXIWJT
      }
      if (/\.aws\.101\.com$/.test(LOC_HOSTNAME)) {
        return AWS
      }
      if (/\.hk\.101\.com$/.test(LOC_HOSTNAME)) {
        return HK
      }
      if (/\.awsca\.101\.com$/.test(LOC_HOSTNAME)) {
        return AWSCA
      }
      if (/\.edmodo\.com$/.test(LOC_HOSTNAME)) {
        return AWSCA
      }
      return AWSCA
  }
})()

const SDP_APP_ID = {
  // prepro: '294ddf8d-705b-454c-bf4b-308389cf60eb',
  // aws_ca: '0ad3a484-aa38-45eb-ad70-0417317feacd'
  prepro: '68fcde65-76e6-4efb-acfa-ba52d26b9214',
  aws_ca: 'dc61053d-fc7e-4b33-8820-116fb3ae0e09'
}
const LOC_RES = {
  module: 'loc',
  protocol: LOC_PROTOCOL,
  host: LOC_HOST,
  ver: 'v0.1'
}

let UC_RES = {
  module: 'uc',
  protocol: 'https://',
  ver: 'v1.1'
}

switch (ENV) {
  case LOCDEVELOPMENT:
  case DEVELOPMENT:
  case DEBUG:
  case PREPRODUCTION:
  case INTEGRATION:
  case PRESSURE:
    UC_RES.host = 'uc-gateway.beta.101.com'
    // UC_RES.host = 'aqapi.101.com'
    // UC_RES.host = 'uc-awsca.101.com'
    // UC_RES.host = 'uc-third-authentication.awsca.101.com'
    break
  case PRODUCTION:
    UC_RES.host = 'uc-gateway.101.com'
    break
  case SHANXIWJT:
    UC_RES.host = 'uc-gateway.sneduyun.com.cn'
    break
  case AWS:
    UC_RES.host = 'uc-gateway.awsca.101.com'
    break
  case HK:
    UC_RES.host = 'uc-gateway.hk.101.com'
    break
  case AWSCA:
    UC_RES.host = 'uc-gateway.awsca.101.com'
    break
  default:
    UC_RES = LOC_RES
  // case PRESSURE:
  //   UC_RES.host = 'ucbetapi.101.com'
  //   // UC_RES.host = 'aqapi.101.com'
  //   // UC_RES.host = 'uc-awsca.101.com'
  //   // UC_RES.host = 'uc-third-authentication.awsca.101.com'
  //   break
  // case PRODUCTION:
  //   UC_RES.host = 'aqapi.101.com'
  //   break
  // case SHANXIWJT:
  //   UC_RES.host = 'uc.sneduyun.com.cn'
  //   break
  // case AWS:
  //   UC_RES.host = 'awsuc.101.com'
  //   break
  // case HK:
  //   UC_RES.host = 'uchk.101.com'
  //   break
  // case AWSCA:
  //   UC_RES.host = 'uc-awsca.101.com'
  //   break
  // default:
  //   UC_RES = LOC_RES
}
const THIRD_LOGIN_URL = {
  url: ''
}
switch (ENV) {
  case LOCDEVELOPMENT:
  case DEVELOPMENT:
  case DEBUG:
  case PREPRODUCTION:
  case INTEGRATION:
  case PRESSURE:
    THIRD_LOGIN_URL.url = 'http://third-party-login.beta.101.com/?type=EDMODO&from=edmodolabs&orgname=VRSERVICETEST&channel_id=10&lang=en-US&is_return_ticket=1&redirect='
    break
  case PRODUCTION:
    break
  case SHANXIWJT:
    break
  case AWS:
    break
  case HK:
    break
  case AWSCA:
    THIRD_LOGIN_URL.url = 'http://third-party-login.awsca.101.com/?type=EDMODO&from=edmodolabs&orgname=101ppt_awsca&channel_id=8&lang=en-US&is_return_ticket=1&&redirect='
    break
}
let CS_RES = {
  module: 'cs',
  ver: 'v0.1'
}

switch (ENV) {
  case LOCDEVELOPMENT:
  case DEVELOPMENT:
  case DEBUG:
  case INTEGRATION:
  case PRESSURE:
    CS_RES.protocol = 'http://'
    CS_RES.host = 'betacs.101.com'
    break
  case PREPRODUCTION:
    CS_RES.protocol = 'https://'
    CS_RES.host = 'betacs.101.com'
    break
  case PRODUCTION:
    CS_RES.protocol = 'https://'
    CS_RES.host = 'cdncs.101.com'
    break
  case SHANXIWJT:
    CS_RES.protocol = 'https://'
    CS_RES.host = 'sdpcs.sneduyun.com.cn'
    break
  case AWS:
    CS_RES.protocol = 'http://'
    CS_RES.host = 'awscs.101.com'
    break
  case HK:
    CS_RES.protocol = 'http://'
    CS_RES.host = 'cdnhkcs.101.com'
    break
  case AWSCA:
    CS_RES.protocol = 'https://'
    CS_RES.host = 'cdn-cs-awsca.101.com'
    break
  default:
    CS_RES = LOC_RES
}

let E_PRODUCT_RES = {
  module: 'E_PRODUCT_RES',
  ver: 'v0.1',
  protocol: 'http://',
  headers: {
  }
}

switch (ENV) {
  case LOCDEVELOPMENT:
  case DEVELOPMENT:
    E_PRODUCT_RES.protocol = 'http://'
    E_PRODUCT_RES.host = 'app-store-api-develop.k8s.sdp.nd'
    E_PRODUCT_RES.headers['sdp-app-id'] = SDP_APP_ID.prepro
    break
  case DEBUG:
    E_PRODUCT_RES.protocol = 'http://'
    E_PRODUCT_RES.host = 'app-store-api-test.k8s.sdp.nd'
    E_PRODUCT_RES.headers['sdp-app-id'] = SDP_APP_ID.prepro
    break
  case INTEGRATION:
    break
  case PRESSURE:
    break
  case PREPRODUCTION:
    E_PRODUCT_RES.protocol = 'https://'
    E_PRODUCT_RES.host = 'app-store-api.beta.101.com'
    E_PRODUCT_RES.headers['sdp-app-id'] = SDP_APP_ID.prepro
    break
  case PRODUCTION:
    E_PRODUCT_RES.protocol = 'https://'
    E_PRODUCT_RES.host = 'edmodo-product.sdp.101.com'
    break
  case AWS:
    E_PRODUCT_RES.protocol = 'https://'
    E_PRODUCT_RES.host = 'edmodo-product.aws.101.com'
    break
  case HK:
    E_PRODUCT_RES.protocol = 'https://'
    E_PRODUCT_RES.host = 'edmodo-product.hk.101.com'
    // E_PRODUCT_RES.headers['sdp-app-id'] = PPT_PC_PROD_APPID
    break
  case AWSCA:
    E_PRODUCT_RES.protocol = 'https://'
    E_PRODUCT_RES.host = 'app-store-api.awsca.101.com'
    E_PRODUCT_RES.headers['sdp-app-id'] = SDP_APP_ID.aws_ca
    break
  case SHANXIWJT:
    E_PRODUCT_RES.protocol = 'https://'
    E_PRODUCT_RES.host = 'edmodo-product.sneduyun.com.cn'
    break
  default:
    E_PRODUCT_RES = LOC_RES
}
let E_PRODUCT2_RES = {
  module: 'E_PRODUCT2_RES',
  ver: 'v0.2',
  protocol: 'http://',
  headers: {
  }
}

switch (ENV) {
  case LOCDEVELOPMENT:
  case DEVELOPMENT:
    E_PRODUCT2_RES.protocol = 'http://'
    E_PRODUCT2_RES.host = 'app-store-api-develop.k8s.sdp.nd'
    E_PRODUCT2_RES.headers['sdp-app-id'] = SDP_APP_ID.prepro
    break
  case DEBUG:
    E_PRODUCT2_RES.protocol = 'http://'
    E_PRODUCT2_RES.host = 'app-store-api-test.k8s.sdp.nd'
    E_PRODUCT2_RES.headers['sdp-app-id'] = SDP_APP_ID.prepro
    break
  case INTEGRATION:
    break
  case PRESSURE:
    break
  case PREPRODUCTION:
    E_PRODUCT2_RES.protocol = 'https://'
    E_PRODUCT2_RES.host = 'app-store-api.beta.101.com'
    E_PRODUCT2_RES.headers['sdp-app-id'] = SDP_APP_ID.prepro
    break
  case PRODUCTION:
    E_PRODUCT2_RES.protocol = 'https://'
    E_PRODUCT2_RES.host = 'edmodo-product.sdp.101.com'
    break
  case AWS:
    E_PRODUCT2_RES.protocol = 'https://'
    E_PRODUCT2_RES.host = 'edmodo-product.aws.101.com'
    break
  case HK:
    E_PRODUCT2_RES.protocol = 'https://'
    E_PRODUCT2_RES.host = 'edmodo-product.hk.101.com'
    // E_PRODUCT_RES.headers['sdp-app-id'] = PPT_PC_PROD_APPID
    break
  case AWSCA:
    E_PRODUCT2_RES.protocol = 'https://'
    E_PRODUCT2_RES.host = 'app-store-api.awsca.101.com'
    E_PRODUCT2_RES.headers['sdp-app-id'] = SDP_APP_ID.aws_ca
    break
  case SHANXIWJT:
    E_PRODUCT2_RES.protocol = 'https://'
    E_PRODUCT2_RES.host = 'edmodo-product.sneduyun.com.cn'
    break
  default:
    E_PRODUCT2_RES = LOC_RES
}
let E_PRODUCT3_RES = {
  module: 'E_PRODUCT3_RES',
  ver: 'v0.3',
  protocol: 'http://',
  headers: {
  }
}

switch (ENV) {
  case LOCDEVELOPMENT:
  case DEVELOPMENT:
    E_PRODUCT3_RES.protocol = 'http://'
    E_PRODUCT3_RES.host = 'app-store-api-develop.k8s.sdp.nd'
    E_PRODUCT3_RES.headers['sdp-app-id'] = SDP_APP_ID.prepro
    break
  case DEBUG:
    E_PRODUCT3_RES.protocol = 'http://'
    E_PRODUCT3_RES.host = 'app-store-api-test.k8s.sdp.nd'
    E_PRODUCT3_RES.headers['sdp-app-id'] = SDP_APP_ID.prepro
    break
  case INTEGRATION:
    break
  case PRESSURE:
    break
  case PREPRODUCTION:
    E_PRODUCT3_RES.protocol = 'https://'
    E_PRODUCT3_RES.host = 'app-store-api.beta.101.com'
    E_PRODUCT3_RES.headers['sdp-app-id'] = SDP_APP_ID.prepro
    break
  case PRODUCTION:
    E_PRODUCT3_RES.protocol = 'https://'
    E_PRODUCT3_RES.host = 'edmodo-product.sdp.101.com'
    break
  case AWS:
    E_PRODUCT3_RES.protocol = 'https://'
    E_PRODUCT3_RES.host = 'edmodo-product.aws.101.com'
    break
  case HK:
    E_PRODUCT3_RES.protocol = 'https://'
    E_PRODUCT3_RES.host = 'edmodo-product.hk.101.com'
    // E_PRODUCT_RES.headers['sdp-app-id'] = PPT_PC_PROD_APPID
    break
  case AWSCA:
    E_PRODUCT3_RES.protocol = 'https://'
    E_PRODUCT3_RES.host = 'app-store-api.awsca.101.com'
    E_PRODUCT3_RES.headers['sdp-app-id'] = SDP_APP_ID.aws_ca
    break
  case SHANXIWJT:
    E_PRODUCT3_RES.protocol = 'https://'
    E_PRODUCT3_RES.host = 'edmodo-product.sneduyun.com.cn'
    break
  default:
    E_PRODUCT3_RES = LOC_RES
}
let sdpAppId = getParameterByName('productid')
if (sdpAppId) {
  sdpAppId = sdpAppId.replace('/', '')
  // E_PRODUCT_RES.headers['sdp-app-id'] = (sdpAppId === PPT_PC_NATIONAL_APPID ? PPT_PC_NATIONAL_APPID : PPT_PC_PROD_APPID) // 发生产的时候，要取消注释，还有打包的config，path也要修改
}
const SessionStorage = new Storage('S-ND-RES-', -1)
const LocalStorage = new Storage('L-ND-RES-', 5 * 24 * 60 * 60)

export default {
  APP_CORE,
  SIMULATION,
  LOCDEVELOPMENT,
  DEVELOPMENT,
  DEBUG,
  PRODUCTION,
  PREPRODUCTION,
  THIRD_LOGIN_URL,
  PRESSURE,
  ENV,
  LOC_RES,
  UC_RES,
  CS_RES,
  E_PRODUCT_RES,
  E_PRODUCT2_RES,
  E_PRODUCT3_RES,
  SessionStorage,
  LocalStorage
}



// WEBPACK FOOTER //
// ./src/utils/config.js